/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class PidxErrorService {
  static DEFAULT_ERROR_KEY = 'pidp.error.backend.message'

  private static getDefaultErrorKey(defaultErrorKey?: string) {
    if (defaultErrorKey) {
      return defaultErrorKey
    }
    return PidxErrorService.DEFAULT_ERROR_KEY
  }

  /***
   * Method that return a custom error-Message based on an error and a inserted map
   *
   * @param error The HttpErrorResponse coming from the BFF
   * @param statusCodeToErrorMap A Map with all wanted statuscodes that are open for translation.
   * 'default'-Code will be an optional default message, if the status code returned doesn't match
   */
  public getErrorKeyForErrorMessageInputByMap(
    error: HttpErrorResponse | null,
    statusCodeToErrorMap: Record<number, string> & { default?: string },
  ): string {
    if (!error) {
      return PidxErrorService.DEFAULT_ERROR_KEY
    }

    // gets the message to the status-code, if there
    if (statusCodeToErrorMap[error.status]) {
      return statusCodeToErrorMap[error.status]
    }

    // custom default case
    if (statusCodeToErrorMap.default) {
      return statusCodeToErrorMap.default
    }

    // default case (if no custom default case is available)
    return PidxErrorService.DEFAULT_ERROR_KEY
  }

  /***
   * Method that return a custom error-Message completely defined in the BFF and gives the opportunity to set a default error message if
   * the extraction of the errorKey from BFF fails
   *
   * @param error The HttpErrorResponse coming from the BFF
   * @param defaultErrorKey the optional default errorKey that can be attached
   */
  public getErrorKeyForHttpErrorResponseByCode(error: HttpErrorResponse | null, defaultErrorKey?: string): string {
    if (!error) {
      return PidxErrorService.getDefaultErrorKey(defaultErrorKey)
    }

    const errorKey = error?.error?.collection?.error?.message

    if (!errorKey || typeof errorKey !== 'string') {
      return PidxErrorService.getDefaultErrorKey(defaultErrorKey)
    }

    return errorKey
  }
}
